import { PRODUCT_TILE_OPTION_DETAILS_SWATCHES_IMAGE_OPTIMIZATION_240423 } from "@faire/web-api/indigofair/settings/PRODUCT_TILE_OPTION_DETAILS_SWATCHES_IMAGE_OPTIMIZATION_240423";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingProductTileOptionDetailsSwatchesImageOptimization = () =>
  getSettingValueWithoutAssignment(
    PRODUCT_TILE_OPTION_DETAILS_SWATCHES_IMAGE_OPTIMIZATION_240423,
    false
  );
